<template>
  <div class="w-full flex flex-row justify-center pt-12 1012-bp:pt-28 font-rubik">
    <div class="w-full max-w-1012 mx-5">
      <h1 class="about-us-text-h1">About Us</h1>
      <section class="text-black" v-html="getRichTextContent"></section>
    </div>
  </div>
</template>
<script>
import jsonFromTemplate from 'shared/json-from-template'
export default {
  data () {
    return {
      blocks: jsonFromTemplate('#page-blocks')
    }
  },
  computed: {
    getRichTextContent() {
      const richTextBlock = this.blocks.find(
        block => block.data.__typename === 'PageRichTextBlock'
      )
      return richTextBlock ? richTextBlock.data.content.html : ''
    }
  }
}
</script>
<style scoped>
.about-us-text-h1 {
  font-size: 56px;
  color: black;
  margin-bottom: 15px;
}
</style>